import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SimpleDataTable from '../../SimpleDataTable';
import { PaymentDetails } from 'src/components/PaymentSearch/PaymentDetails/PaymentDetails';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { observer as classObserver } from 'mobx-react';
import { observable } from 'mobx';
import styled from '@emotion/styled';
import { PaymentDetailsButton } from 'src/components/PaymentSearch/PaymentDetails/PaymentDetails.style';

import { COLUMNS } from './config';
import { get } from 'lodash';
import { any } from 'cypress/types/bluebird';

export const WrappedWordCell = styled('p')`
    white-space: initial;
`;
@classObserver
class PaymentSearchResultsWrapped extends React.Component {
    static propTypes = {};

    static defaultProps = {};

    constructor(props,context ) {
        super(props, context);

        this.state = this.getState(props);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState(this.getState(props));
    }

    getState(props) {
        return {
            payments: props.list.map(id => props.payments.get(id)).toJS()
        };
    }

    render() {
        const { payments } = this.state;
        const { paymentSearchWalletAddress } = this.props;


        return (
            <div>
                <SimpleDataTable
                    className='simple-data-table-container--fixed'
                    header={ true }
                    columns={ COLUMNS }
                    data={ payments }
                    expanded={ (payment) => <ExpandedRow payment={payment} paymentSearchWalletAddress={paymentSearchWalletAddress}/> }
                />
            </div>
        );
    }
}

export const PaymentSearchResults = observer('PaymentSearchResultsWrapped', (props) => {
    const { paymentSearchWalletAddress } = useAppStateContext().configState.config;
    const { list, payments } = props;
    return (
        <PaymentSearchResultsWrapped
            list={ list }
            payments={ payments }
            paymentSearchWalletAddress={ paymentSearchWalletAddress }
        />
    );
});

const ExpandedRow = observer('ExpandedRow', ({payment, paymentSearchWalletAddress}) => {
    const [openModal, setOpenModal] = useState(false);
    let { paymentDetails } = payment;
    let secondColumn;
    let realexLog;
    let reasonColumn;

    if (paymentDetails.assignee) {
        let { name, id } = paymentDetails.assignee;
        secondColumn = (
            <div className='col-4'>
                <h3>Manual Adjustment details:</h3>
                <ul className='bet-search-results__info'>
                    <li>Assignee: { `${name} (ID: ${id})` } </li>
                </ul>
            </div>
        );
    } else if (paymentDetails.provider === 'realex') {
        let { subtype, id, expires } = paymentDetails;

        secondColumn = (
            <div className='col-4'>
                <h3 data-test='expanded-row-card-transaction-details-header'>Card transaction details:</h3>
                <ul className='bet-search-results__info'>
                    <li data-test='expanded-row-card-brand'>Card brand: { subtype || '--' } </li>
                    <li data-test='expanded-row-provider-reference-id'>Provider Reference ID: { id || '--' }</li>
                    <li data-test='expanded-row-expiry-date'>Expiry Date: { expires || '--' }</li>
                </ul>
            </div>
        );
    }

    if (paymentDetails.displayedReason) {
        reasonColumn = (
            <div className='col-4'>
                <h3 data-test='expanded-row-payment-description-header'>Payment Description:</h3>
                <WrappedWordCell data-test='expanded-row-payment-description'>{paymentDetails.displayedReason}</WrappedWordCell>
            </div>
        );
    }

    if (payment.logs) {
        let logs = payment.logs.map(log => {
            let logEntryFields = Object.keys(log.data);
            return (
                <div className='row'>
                    <h3>{ moment(log.date).format('DD/MM/YYYY HH:mm') }</h3>
                    <div className='col-6'>
                        <ul className='bet-search-results__info'>
                            { logEntryFields.map(entry => <li>{entry}: {log.data[entry]}</li>) }
                        </ul>
                    </div>
                    <div className='col-3'>
                        <ul className='bet-search-results__info'>
                            <li>Date: { moment(log.date).format('DD/MM/YYYY HH:mm') }</li>
                            <li>Status change: { log.oldStatus } {'->'} { log.newStatus } </li>
                        </ul>
                    </div>
                </div>
            );
        });
        realexLog = (
            <div className='row'>
                <h3>Realex logs:</h3>
                { logs }
            </div>
        );
    }

    let {
        createdAt,
        finalizedAt,
        updatedAt,
        detailsId,
        event,
        sport,
        expiry,
        category,
        selection,
        rewardType,
        competition,
        number,
    } = paymentDetails;
    const providerAuthCode = get( payment, 'paymentResponse.providerAuthCode');
    const providerOrderId = get( payment, 'paymentResponse.providerOrderId');

    let paymentResponse = payment.paymentResponse;
    let paymentResponseString = JSON.stringify(payment.paymentResponse);

    return (
        <div>
            <div className='row'>
                <div className='col-4'>
                    <h3 data-test='expanded-row-transaction-details-header'>Transaction Details</h3>
                    <ul className="bet-search-results__info">
                        <li data-test='expanded-row-create-date'>Create date: { moment(createdAt).format('DD/MM/YYYY HH:mm') }</li>
                        <li data-test='expanded-row-finalize-date'> Finalize date: { moment(finalizedAt).format('DD/MM/YYYY HH:mm') || '--'}</li>
                        <li data-test='expanded-row-update-date'>Update date: { moment(updatedAt).format('DD/MM/YYYY HH:mm') || '--' }</li>
                        { providerOrderId ? <li className='bet-search-results__details' data-test='expanded-row-order-id'>Order ID: { providerOrderId } </li> : null }
                        { providerAuthCode ? <li className='bet-search-results__details' data-test='expanded-row-auth-code'>Auth Code: { providerAuthCode } </li> : null }
                        { paymentSearchWalletAddress && number !== undefined ? <li className='bet-search-results__details'>Wallet Address: { number } </li> : null }
                    </ul>
                </div>
                { reasonColumn }
                { secondColumn }
            </div>
            { realexLog }
            {paymentResponse !== null ? <PaymentDetailsButton onClick={() => setOpenModal(true)} data-test='payment-details-button'>More details</PaymentDetailsButton> : null}
            {openModal === true ? <PaymentDetails moreDetails={setOpenModal} paymentResponseString={paymentResponseString} /> : null}
        </div>
    );
});
